import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row } from 'antd';

import { ItemLabelWraper, ItemValueWrapper } from '../styled';

import { isPlainObject, map, startCase } from '../../../../util/lodashlike';
const InnerRowWrapper = styled(Row)`
  border: red;
  padding-left: 20px;
  margin-top: 10px;
`;

const getItemValue = (value) => (value ? value : '-');

const NestedLabelItem = ({ itemLabel, itemValue }) => (
  <>
    {isPlainObject(itemValue) ? (
      <ItemLabelWraper span="24">
        {itemLabel}
        <InnerRowWrapper gutter={[5, 10]}>
          {map(itemValue, (value, key) => (
            <Fragment key={key}>
              <ItemLabelWraper span="12">{startCase(key)}</ItemLabelWraper>
              <ItemValueWrapper span="12">
                {getItemValue(value)}
              </ItemValueWrapper>
            </Fragment>
          ))}
        </InnerRowWrapper>
      </ItemLabelWraper>
    ) : (
      <>
        <ItemLabelWraper span="12">{itemLabel}</ItemLabelWraper>
        <ItemValueWrapper span="12">{getItemValue(itemValue)}</ItemValueWrapper>
      </>
    )}
  </>
);

NestedLabelItem.propTypes = {
  itemLabel: PropTypes.string.isRequired,
  itemValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default NestedLabelItem;
